import { IndicatorOptions } from "./scanview.types";

export const defaultMessages = {
  manualCaptureTitle: "Use camera button to scan card",
  frontsideCompletedTitle:
    "Front side scan is complete\nRotate card to scan back",
  autoCaptureTitle: "Hold Card in Frame\nIt Will Scan Automatically",
  processingTitle: "Keep Card Still While Scanning",
  postProcessing: "Validating Insurance Card...",
  completedTitle: "Card Scanned Successfully",
  errorTitle: `Setup Failure - Please Reload the Page`,
  retryTitle: `Scanning Failed - Please Try Again`,
  cameraErrorTitle: "Unable to Setup Camera for Capture",
  eligibilityProcessing: "Checking eligibility",
  eligibilityErrorTitle: "Eligibility Setup Failure",
};

export const defaultIndicatorOptions = {
  name: "ball-spin-fade-loader",
  fadeIn: "none",
  color: "#FFF",
} as IndicatorOptions;
